export const config = {
    apiKey: "AIzaSyBxXuV8jIPHEYN-BIyxqDmYUTqRvvYiWZY",
    authDomain: "sift-ee194.firebaseapp.com",
    databaseURL: "https://sift-ee194.firebaseio.com",
    projectId: "sift-ee194",
    storageBucket: "sift-ee194.appspot.com",
    messagingSenderId: "684447484556",
    appId: "1:684447484556:web:d2d353109c9765eecf09a9",
    measurementId: "G-P7S0B9QQ4R"
};